
import { Meeting } from "../../types/meetings";
import { useNavigate } from "react-router-dom";
import { useUserTimezone } from "../../hooks/useUserTimezone";
import { formatDate } from "../../utils/date";
import React from "react";

interface DashboardMeetingCardProps {
  meeting: Meeting;
}

export function DashboardMeetingCard({ meeting }: DashboardMeetingCardProps) {
  const navigate = useNavigate();
  const { timezone } = useUserTimezone();

  const handleClick = () => {
    navigate(`/app/meeting/${meeting.id}`);
  };

  const getMeetingTitle = () => {
    if (!meeting.title) {
      return meeting.created_at ? formatDate(meeting.created_at, timezone) : 'Untitled Meeting';
    }
    return meeting.title;
  };

  return (
    <button
      onClick={handleClick}
      className="w-full group bg-background/75 hover:bg-primary/5 rounded-full py-2 md:pl-10 pl-6 md:pr-2 transition-all duration-200"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0 pr-4">
          <h3 className="text-base text-primary font-semibold text-left line-clamp-1">
            {getMeetingTitle()}
          </h3>
          
          <div className="flex items-center gap-2 mt-1.5 min-w-0">
            <span className="text-muted-foreground text-xs truncate">
              {meeting.created_at ? formatDate(meeting.created_at, timezone) : 'No date'}
            </span>
          </div>
        </div>
        <div className="text-foreground md:pr-4 pr-2 group-hover:translate-x-1 transition-transform shrink-0">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </button>
  );
}
